import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const InfoIcon = ({ fill='#4DB6F7', border='#000', ...props}) => {
  return (
    <Icon viewBox="0 0 72 72" {...props}>
      <g fill="none">
        <path
          fill={border}
          d="M36.0001,72.0001 C16.1491,72.0001 0.0001,55.8501 0.0001,36.0001 C0.0001,16.1491 16.1491,0.0001 36.0001,0.0001 C55.8501,0.0001 72.0001,16.1491 72.0001,36.0001 C72.0001,55.8501 55.8501,72.0001 36.0001,72.0001"
        />
        <path
          fill={fill}
          d="M36.0001,5.8947 C19.4001,5.8947 5.8951,19.3997 5.8951,35.9997 C5.8951,52.6007 19.4001,66.1047 36.0001,66.1047 C52.6001,66.1047 66.1051,52.6007 66.1051,35.9997 C66.1051,19.3997 52.6001,5.8947 36.0001,5.8947"
        />
        <path
          fill={border}
          d="M39.4987,51.4215 C40.3987,51.4215 41.0987,50.7215 41.0987,49.8215 L41.0987,48.2225 C41.0987,47.3225 40.3987,46.6225 39.4987,46.6225 L39.5497,33.8255 C39.5497,32.9265 38.7997,32.2265 37.9497,32.2265 L32.5017,32.2265 C31.6007,32.2265 30.9017,32.9265 30.9017,33.8255 L30.9017,35.4255 C30.9017,36.3245 31.6007,37.0255 32.5017,37.0255 L32.5017,46.6225 C31.6007,46.6225 30.9017,47.3225 30.9017,48.2225 L30.9017,49.8215 C30.9017,50.7215 31.6007,51.4215 32.5017,51.4215 L39.4987,51.4215 Z M39.6495,24.2775 C39.6495,22.3785 37.9495,20.5785 36.0005,20.5785 C34.0505,20.5785 32.3505,22.3785 32.3505,24.2775 C32.3505,26.2275 34.0505,27.8775 36.0005,27.8775 C37.9495,27.8775 39.6495,26.2275 39.6495,24.2775 Z"
        />
      </g>
    </Icon>
  );
};

InfoIcon.propTypes = {
  fill: PropTypes.string,
  border: PropTypes.string,
};

export default InfoIcon;
